import { Language } from './types';

const enBase = {
  common: {
    book: "Readings",
    portal: "Member Portal",
    signIn: "Sign In",
    offerings: "Offerings",
    circles: "Circles",
    community: "Community",
    back: "Back",
    loading: "Aligning with the Heavens...",
    home: "Home",
    chart: "Chart",
    vault: "Vault",
    chat: "Chat",
    settings: "Settings"
  },
  hero: {
    tag: "Consulting the Heavens",
    subtitle: "Astrology",
    by: "by Allie",
    desc: "Unlock the fated secrets of your soul through precision planetary alignment. Allie provides a sanctuary between the celestial sphere and your personal journey.",
    btnChart: "Free Birth Chart",
    btnBook: "Book A Reading",
  },
  services: {
    tag: "Offerings",
    title: "Divine Consultations",
    duration: "Duration",
    learnMore: "Learn More",
  },
  about: {
    tag: "The Astrologer",
    title: "Meet Allie",
    exp: "Years Experience",
    delivered: "Readings Delivered",
    btn: "Start Your Journey",
    connect: "How We Connect",
    secure: "Secure Upfront Exchange",
  },
  destiny: {
    tag: "Exclusive Cosmic Transmission",
    title: "The Secret Points of Destiny",
    desc: "Beyond the sun and moon lie the mysterious Vertex and the Part of Fortune. Allie's precise engine maps your points of fated encounter, hidden abundance, and powerful critical degrees.",
    btn: "Unlock Destiny Report ($20)",
  },
  membership: {
    tag: "Soul Circles",
    title: "Celestial Memberships",
  },
  chat: {
    lockedTitle: "Channel Dormant",
    lockedDesc: "Your direct transmission line to Allie activates upon booking your first session. Align your energies with a consultation to unlock this sanctuary.",
    bookNow: "View Offerings",
    initiateVideo: "Video Call",
    initiateAudio: "Audio Call",
    sendPlaceholder: "Compose soul transmission...",
    online: "ONLINE",
    offline: "OFFLINE"
  },
  portalHome: {
    blueprintTitle: "Your Cosmic Blueprint",
    blueprintDesc: "Your birth chart is a sacred snapshot of the heavens at your exact moment of entry. It maps the fated architecture of your personality, purpose, and karmic path.",
    fluctuationTitle: "Fixed Map vs. Moving Stars",
    fluctuationDesc: "Your natal chart is permanent and fixed. Daily horoscopes reflect 'Transits'—how current planets interact with your stationary natal positions. We re-verify coordinates to ensure mathematical precision.",
    miniChartTitle: "Mini Soul Map",
    viewFull: "View Full Alignment"
  },
  footer: {
    links: "Quick Links",
    connect: "Connect",
    rights: "All rights reserved.",
  }
};

export const translations: Record<Language, any> = {
  en: enBase,
  es: {
    ...enBase,
    common: { ...enBase.common, book: "Readings", portal: "Portal de Miembros", signIn: "Iniciar Sesión" },
    hero: { ...enBase.hero, tag: "Consultando a los Cielos", subtitle: "Astrología", by: "por Allie" }
  },
  zh: { ...enBase, common: { ...enBase.common, home: "首页", chart: "星盘", vault: "金库", chat: "聊天", settings: "设置" } },
  ja: { ...enBase, common: { ...enBase.common, home: "ホーム", chart: "チャート", vault: "ヴォルト", chat: "チャット", settings: "設定" } },
  ru: { ...enBase, common: { ...enBase.common, home: "Главная", chart: "Карта", vault: "Хraнилище", chat: "Чат", settings: "Настройки" } },
  de: { ...enBase, common: { ...enBase.common, home: "Home", chart: "Horoskop", vault: "Tresor", chat: "Chat", settings: "Einstellungen" } }
};